export const inviteFriendEndpoint = 'profilo-ms/ms/profile/invite/friend';
export const setTermsEndpoint = 'profilo-ms/ms/profile/terms';
